import { inject, Injectable } from "@angular/core";
import { VcsService } from "@wms/app/vcs/services/vcs.service";
import { DialogService, NotificationService } from "@wms/services";
import { BaseComponent } from "@wms/components";
import { VcsAPIService } from "@wms/app/vcs/services/vcs-api/vcs-api.service";

@Injectable({
  providedIn: "root"
})

export class PrefabPublishService extends BaseComponent {
  selectedProject: string;
  oldSelectedProject: string;
  prefabToProjectList: any[] = [];
  copyPrefabToProjectList: any[] = [];
  ARTIFACTS_PUBLISH_DOC_API_URL: string = '/studio/services/projects/:projectID/prefabDoc';
  private vcsApiService = inject(VcsAPIService);

  constructor(private vcsService: VcsService, private dialogService: DialogService, private notificationService: NotificationService) {
    super();
  }

  publishPrefabToTeam() {
    this.eventManager.emitSavePageWorkspace(this.checkAndPushToVCS.bind(this));
  }

  checkAndPushToVCS() {
    if(this.projectService.teamProjectObject.vcsAccountDTO.mrFlowEnabled) {
      this.vcsApiService.validateNoChanges().then(() => {
        this.openPublishToTeamDialog();
      }, (error) => {
        if(error && error.status === 400 && error.error.errors.error[0].messageKey === "com.wavemaker.vcs$haveUnPushedChanges") {
          this.notificationService.show('error', this.locale['MESSAGE_ERROR_TITLE'], this.locale.MSG_ERROR_UNPUSHED_CHANGES);
        }
        if(error && error.status === 400 && error.error.errors.error[0].messageKey === "com.wavemaker.vcs$unMergedChanges") {
          this.notificationService.show('error', this.locale['MESSAGE_ERROR_TITLE'], this.locale.MSG_ERROR_UNMERGED_CHANGES);
        }
      });
    } else {
      this.vcsService.openPushProjectDialog(this.openPublishToTeamDialog.bind(this));
    }
  }

  openPublishToTeamDialog() {
    this.eventManager.emitPublishToTeamInit();
    this.dialogService.open('publish-to-team');
  }

  publishPrefabToWorkSpace() {
    this.eventManager.emitSavePageWorkspace(this.checkRepoStatus.bind(this));
  }
  checkRepoStatus() {
    this.vcsService.checkRepoStatus(this.openPublishToWorkspaceDialog.bind(this));
  }

  openPublishToWorkspaceDialog() {
    this.dialogService.open('publish-to-workspace')
    this.eventManager.emitPublishToWorkspace("refresh")
  }
  getArtifactCategories(categories: any[], processing: boolean, artifactPublishDetails: any): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      if (!categories.length || artifactPublishDetails.newCategory) {
        processing = true;
        this.projectService.getCategories().then((projectCategories: any) => {
          projectCategories.forEach((category: any) => {
            categories.push(category.name);
          });
          resolve();
        }, (error: any) => {
          processing = false;
          this.notificationService.show('error', this.locale.MESSAGE_ERROR_TITLE, error);
          reject();
        });
      } else {
        resolve();
      }
    });
  }
  getProjects() {
    this.prefabToProjectList = [];
    this.copyPrefabToProjectList = [];
    const projectDetails = this.projectService.getDetails();
    if (this.oldSelectedProject)
      this.selectedProject = this.oldSelectedProject;
    (this.projectService.getProjectDetails('MAIN,BRANCH') as Promise<any>).then(
      (response: any) => {
        const sortedProjects = this.sortObjectsAlphabetically(response,"name")
        const filteredProjects = sortedProjects.filter((project)=> project.name !== projectDetails.name)
        this.prefabToProjectList = filteredProjects;
        this.copyPrefabToProjectList = filteredProjects;
        this.dialogService.open('publish-to-project');
      }
    ).catch((error) => {
      this.notificationService.show('error', this.locale['MESSAGE_ERROR_TITLE'], error.error.errors.error[0].message)
    })
  }
  sortObjectsAlphabetically(array: any[], property: string) {
    return array.sort((a: any, b: any) => {
      const propA = a[property].toLowerCase();
      const propB = b[property].toLowerCase();

      if (propA < propB) {
        return -1;
      }
      if (propA > propB) {
        return 1;
      }
      return 0;
    });
  }
}
